import React from 'react';
import { Box, Heading, Text, VStack, Grid, Button, Flex } from '@chakra-ui/react';

function LevelCard({ bg, children }) {
  return (
    <Box
      bg={bg}
      borderRadius="20px"
      px="30px"
      py="30px"
      h="125px"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      overflow="hidden"
    >
      <Box w="100%">
        <Heading
          as="h3"
          fontSize="20px"
          fontWeight="bold"
          fontFamily="Inter, sans-serif"
          color="black"
          letterSpacing="0.1px"
          lineHeight="1.2"
        >
          {children}
        </Heading>
      </Box>
    </Box>
  );
}

export default function LevelsSection() {
  return (
    <Flex 
    as="section"
    flexDirection={"column"}
    alignItems={"center"}
    justifyContent={"center"}
    aria-label="Groupes de niveau" w={"100%"}
    alignSelf={"center"}
    maxW={"710px"} gap="20px" py={"50px"}>
      <Box
        borderRadius="40px"
        w="100%"
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
      >
        <VStack spacing="5px" align="center">
          <Heading
            as="h2"
            fontSize={{ base: "30px", md: "45px" }}
            fontWeight="bold"
            fontFamily="Inter, sans-serif"
            color="black"
            textAlign={{base:"left", md:"center"}}
            letterSpacing="0.1px"
            lineHeight="1.2"
          >
            Tu as peur de te lancer ?
          </Heading>
          <Text
            fontSize={{ base: "14px", md: "20px" }}
            fontFamily="Inter, sans-serif"
            fontWeight="normal"
            color="black"
            textAlign={{ base: "left", md: "center" }}
            letterSpacing="0.1px"
            lineHeight={{ base: "1.6", md: "1.4" }}
          >
            Ne t'inquiète pas ! Tu as accès à des groupes de niveau !
            <br />
            Et chaque personne a pour mission de t'offrir le meilleur accueil possible.
          </Text>
        </VStack>
      </Box>
      <Grid
        templateColumns={{ base: "1fr", md: "repeat(3, 1fr)" }}
        gap="20px"
        w="100%"
      >
        <LevelCard bg="#c7e5f4">
          Niveau<br />Débutant
        </LevelCard>

        <LevelCard bg="#c0e9db">
          Niveau<br />Intermédiaire
        </LevelCard>

        <LevelCard bg="#b2f0b0">
          Niveau<br />Confirmé
        </LevelCard>
      </Grid>
      <Flex marginTop={"50px"} flexDirection={"column"} maxW={"332px"} alignItems={"center"} justifyContent={"center"} gap="20px">
      <Heading
          as="h3"
          fontSize="20px"
          fontWeight="bold"
          fontFamily="Inter, sans-serif"
          color="black"
          letterSpacing="0.1px"
          lineHeight="1.2"
          textAlign={"center"}
        >
          Tu peux aussi échanger avec nous pour en savoir plus
        </Heading>
        <Button
          as="a"
          href="https://discord.gg/qJhmqbmcb2"
          target="_blank"
          rel="noopener noreferrer"
        >
          Rejoins la FAQ Discord
        </Button>
      </Flex>
    </Flex>
  );
}
